/* RESPONSIBLE TEAM: team-standalone */
/* eslint-disable @intercom/intercom/no-bare-strings */

import { inject as service } from '@ember/service';
import Helper from '@ember/component/helper';
import type CopilotApi from 'embercom/services/copilot-api';

type ExternalCopilotTypeSignature = {
  Args: {
    Positional: [externalType?: number];
  };
  Return: string;
};

export default class ExternalCopilotType extends Helper<ExternalCopilotTypeSignature> {
  @service declare copilotApi: CopilotApi;

  compute([externalType]: [number?]) {
    let typeToUse = externalType ?? this.copilotApi.externalType;

    let mapping = {
      1: 'ticket',
      6: 'case',
      31: 'messaging conversation',
    };

    if (!typeToUse) {
      return 'conversation';
    }

    return mapping[typeToUse as keyof typeof mapping] || 'conversation';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'external-copilot-type': typeof ExternalCopilotType;
  }
}
